import { motion } from "framer-motion";
import { TiTick } from "react-icons/ti";

export default function FlexLayout({
  heading,
  text,
  list,
  img,
  alt,
  reverse = false,
}) {
  return (
    <section className="space-y-10 container ">
        <div className=" mx-auto md:w-11/12 lg:w-10/12 xl:w-9/12  space-y-5 ">

        <motion.h2
          initial={{ opacity: 0, y: 40 }} 
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.3 }}
          className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[50px]  font-bold text-center   text-dark font-butler  "
        >
          {heading}{" "}
        </motion.h2> 
         {  text && <p className="text-base leading-[1.625rem] text-center  text-dark ">
          {text}</p>}
          </div>
    <div
      className={`flex ${reverse ? "flex-col xl:flex-row-reverse " : "flex-col xl:flex-row "} space-y-10 xl:space-y-0 justify-between items-center  xl:space-x-10 sm:px-10 lg:px-0 `}
    >
      <div className="space-y-10 w-full xl:w-7/12 ">
     
        <ul className="space-y-2 text-lg">
          {list.map((content, i) => {
            return (
              <li key={i} className="flex items-start text-dark  space-x-2 ">
                <span className="text-dark  bg-[#FFC067] rounded-full p-0.5  mt-1">
                  <TiTick />
                </span>
                <div>
                  <span className="inline text-lg font-bold m-0">
                    {content.boldText}:{" "}
                  </span>{" "}
                  <span className="text-base leading-[1.625rem] text-dark inline">{content.text}</span>
                </div>
              </li> 
            );
          })}
        </ul>
      </div>
      <div className="w-10/12 md:w-7/12 lg:w-8/12 xl:w-4/12 ">
        <img src={img} alt={alt} className="rounded w-full   md:w-10/12 lg:w-11/12 2xl:w-11/12 mx-auto" />
      </div>
    </div>
    </section>

  );
}
